import { SubscriptionType } from "_constants/SubscriptionConstants";
import { ProductSelectionConst } from "../SelectProduct/ProductSelectionLogic";

const VSTS_FEEWAIVER = 1;
const VSTT_FEEWAIVER_100 = 2;
const VSTT_FEEWAIVER_50 = 3;

export const FeeWaiverConst = {
  VSTS_FEEWAIVER,
  VSTT_FEEWAIVER_100,
  VSTT_FEEWAIVER_50,
};

export  const showFeeWaiverOption = (option, selectedSubscriptionSet) => {
  for (var i = 0; i < option.productSubscriptionIds.length; i++) {
    if (selectedSubscriptionSet.has(option.productSubscriptionIds[i]) || option.hasSetupFee) return true;
  }
  return false;
}

// returns negative value - just add to total value
export const applyFeeWaiverToProductFee = (product, selectedFeeWaiver) => {
  //Annual VSTT Subscription
  if (product.recurringIntervalType === ProductSelectionConst.YEARLY_SUBSCRIPTION_INTERVAL) return 0;
  //Monthly VSTT or VSTS Subscription
  else return -calculateDiscountValue(product.fee, selectedFeeWaiver.percentage);
}

export const applyFeeWaiverToSetupFee = (product, selectedFeeWaiver) => {
  if (!product.hasSetUp) return 0;
  else return -calculateDiscountValue(product.setUpSubscription.fee, selectedFeeWaiver.percentage);
}

export const calculateDiscountValue = (value, percentage) => {
  return value * percentage / 100;
}

export const findProductToApplyFeeWaiver = (productList, selectedFeeWaiver) => {
  return productList.find(product => product.productId === selectedFeeWaiver.productId);
}

export const filterVSTTFeeWaiverOptions = (selectedSubscriptionSet, feeWaiverOptions) => {
  const updatedFilteredFeeWaiverOptions = []
  feeWaiverOptions.forEach((item) => {
    if (showFeeWaiverOption(item, selectedSubscriptionSet)) updatedFilteredFeeWaiverOptions.push(item);
  })
  return updatedFilteredFeeWaiverOptions;
} 

export const parseToFeeWaiverDescription = (subscriptionType, feeWaiver, product) => {
  return subscriptionType == SubscriptionType.Subscription ? 
        feeWaiver.description : 
        `${feeWaiver.description} ${product.productCategory.shortName} ${product.name}`
}

export const GetUSDCurrencyString = (number) => {
  return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: 'USD',
      currencyDisplay: 'narrowSymbol',
      maximumFractionDigits: 0,
      minimumFractionDigits: 0,
  }).format(number) + " USD"
}

export const AlignRight = {
  textAlignLast: "right"
}
export const AlignPadRight = {
  textAlignLast: "right",
  paddingLeft: "100px"
}
export const AlignPadLeft = {
  textAlignLast: "right",
  paddingRight: "100px"
}